;(function (window, document) {
  const variable = "--full-viewport";
  const classResize = 'resize-active';
  let resizeTimer;
  function vh() {
    document.documentElement.style.setProperty(variable, `${window.innerHeight}px`);
  }
  function resizeHandler() {
    document.documentElement.classList.add(classResize);
    clearTimeout(resizeTimer);
    
    resizeTimer = setTimeout(()=> {
      document.documentElement.classList.remove(classResize);
    }, 300)
  }
  vh();
  window.addEventListener("resize", function () {
    vh();
    resizeHandler();
  });
})(window, document)
